<div class="d-flex">
	<span *ngxPermissionsOnly="['Administrador']"><i (click)="showInfoDiaria()" title="Agregar Informacion Diaria" class="{{'Editar' | parseIconAccion }} pointer pb-0"></i></span>
	<div>
		<label class="pl-1 pb-0 d-block">Observaciones<label class="m-0 font-weight-500">:&nbsp;&nbsp;{{observaciones}}</label></label>
		<label class="pl-1 pb-0 d-block">Precipitaciones<label class="m-0 font-weight-500">:&nbsp;&nbsp;{{precipitaciones}}</label></label>
	</div>
</div>
